import { FormControlLabel, Radio, RadioGroup } from "@mui/material";

export function MiRadioGroup({
  data,
  value,
  orientation,
  handleChange,
  radioSize = "small",
}) {
  return (
    <RadioGroup
      row={orientation === "row"}
      value={value}
      onChange={handleChange}
    >
      {data.map((obj) => {
        return (
          <FormControlLabel
            key={obj.value}
            value={obj.value}
            control={<Radio size={radioSize} />}
            label={obj.label}
            disabled={obj.disabled}
          />
        );
      })}
    </RadioGroup>
  );
}
